import React, { Component } from 'react';
import Carousel from '../Carousel';
import CardMLPModule from './CardMLPModule';
import { FormattedMessage } from '../Intl';
import EdapModuleView from '../EdapModuleView';
import { Experiment } from '../Experiment';
import { HA_PTA_HP_MERCHANDISINGMODULE } from './constants';
import { messageKeys, getMessages } from './translations';
import { mlpModuleClick, MLPMODULE_CLICK_PREV, MLPMODULE_CLICK_NEXT } from './events';
import { handleEdapClick, triggerEdapEvent } from '../../utils/edap';
import { MODULE_VIEW_EVENT_OPTIONS } from './events';

class MLPModule extends Component {
  handlePreviousClick() {
    triggerEdapEvent(MLPMODULE_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(MLPMODULE_CLICK_NEXT);
  }

  render() {
    const { mlpsImages } = this.props;

    const mlpsImagesFilteredEntries = Object.entries(mlpsImages).filter(([, value]) => value.image);
    const mlpsImagesLength = mlpsImagesFilteredEntries.length;

    return (
      !!mlpsImagesLength && mlpsImagesLength > 4 &&
      <Experiment name={HA_PTA_HP_MERCHANDISINGMODULE} report>
        {value => (
          value === 1 ?
            (
              <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
                <FormattedMessage id={messageKeys}>
                  {(...messages) => {
                    const msgs = getMessages(messages);
                    return (
                      <section className="Content__section">
                        <Carousel
                          onPreviousClick={this.handlePreviousClick}
                          onNextClick={this.handleNextClick}
                          title={msgs.title}
                          subheading={msgs.subHeading}
                        >
                          {(mlpsImagesFilteredEntries).map(([theme, obj]) => (
                            <CardMLPModule
                              key={theme}
                              title={msgs[theme].title}
                              subtitle={msgs[theme].subtitle}
                              clickUrl={obj.url}
                              imageUri={obj.image}
                              onClick={handleEdapClick(mlpModuleClick(theme))}
                            />
                          ))}
                        </Carousel>
                      </section>
                    );
                  }}
                </FormattedMessage>
              </EdapModuleView>
            ) : null
        )}
      </Experiment>
    );
  }
}

export default MLPModule;
